import { render, staticRenderFns } from "./LocationProductDetail.vue?vue&type=template&id=125fdfd5&scoped=true"
import script from "./LocationProductDetail.vue?vue&type=script&lang=js"
export * from "./LocationProductDetail.vue?vue&type=script&lang=js"
import style0 from "./LocationProductDetail.vue?vue&type=style&index=0&id=125fdfd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125fdfd5",
  null
  
)

export default component.exports